export const SEARCH_KEY_CONTACT_IDS = 'contactIds';
